import apartmentsContent from 'content/apartmentsContent.json'

export const homePageByLocale = {
  'en-us': {
    metaDescription:
      'Introducing the first Condo Hotel in the heart of Griffintown, offering 126 stylishly furnished and fully-equipped apartments just a walk-away from downtown Montreal.',
    hero: {
      heading: 'Your Home Away from Home',
      description:
        'Introducing the first Appart-Hotel in the heart of Griffintown, offering stylishly furnished and fully-equipped apartments just a walk-away from downtown Montreal.',
    },
    suites: {
      eyebrow: 'Our Condo Hotel Apartments',
      heading: 'Fully-Equipped Apartments',
      subheading:
        'All our apartments offer fully-equipped kitchens with modern appliances, including a washer and a dryer. Browse through our vast selection of well-appointed apartments below, starting with our 1-bedroom apartments to our more spacious 2-bedroom apartments.',
    },
    neighbourhood: {
      eyebrow: 'Neighbourhood',
      heading: 'Located in Downtown Montreal',
      description:
        'Located on Bassins Street, the hotel is in the centre of the action in Soho-like Griffintown, buzzing with restaurants, proximity services and parks that have transformed the neighbourhood into one of the most coveted in Montreal.',
    },
    experience: {
      eyebrow: 'Our Concept',
      heading: 'Your Home Away from Home',
      description:
        'There’s no place like home. So, we made sure all our apartments would give you the comfort of home with a little touch of amazing. Our condo-like apartments are fully and beautifully equipped, starting with luxurious appliances, such as a Bloomberg fridge, modern cooking top, stove, washer-dryer and even more. Plus, to make you feel even more at home, you’ll find everything you need to cook, bake and entertain in a modern kitchen. Food and drinks can even be ordered prior to your arrival.',
    },
  },
  'fr-ca': {
    metaDescription:
      'Bienvenue au Griffintown Hōtel, le premier appart-hôtel au cœur de Griffintown, offrant des appartements élégamment meublés et entièrement équipés, à quelques pas du centre-ville de Montréal.',
    hero: {
      heading: 'Un confort comme chez soi',
      description:
        'Bienvenue au Griffintown Hōtel, le premier appart-hôtel au cœur de Griffintown, offrant des appartements élégamment meublés et entièrement équipés, à quelques pas du centre-ville de Montréal.',
    },
    suites: {
      eyebrow: 'Nos appartements',
      heading: 'Appartements entièrement équipés',
      subheading:
        "Tous nos appartements offrent une cuisine entièrement équipée avec des électroménagers modernes, y compris une machine à laver et une sécheuse. Nous avons pensé à tout afin de vous offrir un confort comme à la maison. Explorez ci-dessous notre vaste sélection d'appartements bien aménagés, en commençant par nos appartements à 1 chambre et nos appartements à 2 chambres, plus spacieux.",
    },
    neighbourhood: {
      eyebrow: 'Quartier',
      heading: 'Situé au coeur de Griffintown',
      description:
        "Situé sur la rue des Bassins près de la rue Wellington, notre projet est au cœur de Griffintown, où de nouveaux restaurants, services et parcs ont transformé le quartier en l'un des plus convoités de Montréal.",
    },
    experience: {
      eyebrow: 'Notre concept',
      heading: 'Une expérience inégalée',
      description:
        "Au Griffintown Hotel tous les appartements disposent d'une grande cuisine entièrement équipée, de salles de bains en marbre, de balcons privés et de draps fins. Puis, enveloppé d'un décor d'une couleur neutre et douce, vous allez pouvoir vous reposer après une promenade dans le Vieux-Montréal ou après vos réunions d'affaires.",
    },
  },
}

export function homeApartmentCardsForLocale(locale) {
  const categories = apartmentsContent[locale] || []
  const cards = []
  for (const cat of categories) {
    for (const apt of cat.apartments) {
      cards.push({
        slug: apt.slug,
        title: apt.title,
        beds: apt.beds,
        size: apt.size,
        imageUrl: apt.imageUrl,
      })
    }
  }
  return cards
}
